/**
 * DRAWER MENU ULTIMATE - JavaScript
 * Multi-niveaux illimité + Fermeture automatique siblings
 */

(function() {
  'use strict';
  
  const state = {
    isOpen: false,
    currentLevel: 0,
    history: [],
    scrollPosition: 0,
    isMobile: false
  };
  
  const elements = {
    drawer: document.getElementById('drawerMenu'),
    overlay: document.getElementById('drawerOverlay'),
    container: document.getElementById('drawerContainer'),
    closeButtons: null,
    backButtons: null,
    submenuButtons: null
  };
  
  function init() {
    if (!elements.drawer) {
      return;
    }
    
    elements.closeButtons = elements.drawer.querySelectorAll('.drawer-close');
    elements.backButtons = elements.drawer.querySelectorAll('[data-back]');
    elements.submenuButtons = elements.drawer.querySelectorAll('[data-submenu-target]');
    
    // Close buttons: niveau 0 ferme tout, autres niveaux = back
    // Inclut les boutons dans le header ET dans le breadcrumb
    elements.closeButtons.forEach((btn, index) => {
      btn.addEventListener('click', function() {
        const parentPanel = this.closest('.drawer-panel');
        const level = parentPanel ? parseInt(parentPanel.getAttribute('data-panel-level')) : 0;
        
        if (level === 0) {
          close();
        } else {
          navigateBack();
        }
      });
    });
    
    elements.overlay.addEventListener('click', close);
    
    elements.backButtons.forEach(btn => {
      btn.addEventListener('click', navigateBack);
    });
    
    // Submenu buttons avec fermeture automatique siblings
    elements.submenuButtons.forEach(btn => {
      btn.addEventListener('click', function() {
        const targetId = this.getAttribute('data-submenu-target');
        const siblingGroup = this.getAttribute('data-submenu-siblings');
        navigateTo(targetId, siblingGroup);
      });
    });
    
    document.addEventListener('keydown', handleKeyboard);
    
    updateResponsive();
    window.addEventListener('resize', debounce(updateResponsive, 250));
    
    window.DrawerMenu = {
      open: open,
      close: close,
      navigateTo: navigateTo,
      navigateBack: navigateBack,
      reset: reset
    };
    
  }
  
  function open() {
    saveScrollPosition();
    lockBody();
    elements.drawer.classList.add('is-open');
    state.isOpen = true;
    fitDrawer();
    trapFocus();
  }
  
  function close() {
    elements.drawer.classList.remove('is-open');
    state.isOpen = false;
    unlockBody();
    restoreScrollPosition();
    removeFocusTrap();
    setTimeout(reset, 300);
  }
  
  function reset() {
    state.currentLevel = 0;
    state.history = [];
    
    const subPanels = elements.drawer.querySelectorAll('.drawer-panel-sub');
    subPanels.forEach(panel => {
      panel.classList.remove('is-visible');
      panel.style.display = 'none';
    });
    
    elements.container.classList.remove('has-subpanel');

    fitDrawer();

    const breadcrumb = elements.drawer.querySelector('#drawerBreadcrumb');
    if (breadcrumb) {
      breadcrumb.style.display = 'none';
    }
  }
  
  // Navigation avec fermeture automatique des siblings
  function navigateTo(panelId, siblingGroup) {
    const targetPanel = document.getElementById(panelId);
    if (!targetPanel) return;
    
    // FERMER TOUS LES SIBLINGS du même groupe
    if (siblingGroup) {
      const allSiblings = elements.drawer.querySelectorAll(`[data-submenu-siblings="${siblingGroup}"]`);
      allSiblings.forEach(btn => {
        const otherPanelId = btn.getAttribute('data-submenu-target');
        if (otherPanelId !== panelId) {
          const otherPanel = document.getElementById(otherPanelId);
          if (otherPanel && otherPanel.classList.contains('is-visible')) {
            closePanelAndChildren(otherPanel);
          }
        }
      });
    }
    
    const newLevel = parseInt(targetPanel.getAttribute('data-panel-level'));
    
    state.history.push({
      panelId: panelId,
      level: newLevel
    });
    
    state.currentLevel = newLevel;
    
    targetPanel.style.display = 'flex';
    
    requestAnimationFrame(() => {
      targetPanel.classList.add('is-visible');
      elements.container.classList.add('has-subpanel');
      fitDrawer();
    });

    updateBreadcrumb();
  }
  
  // Ferme un panel ET tous ses enfants récursivement
  function closePanelAndChildren(panel) {
    panel.classList.remove('is-visible');
    
    setTimeout(() => {
      panel.style.display = 'none';
    }, 300);
    
    // Trouver et fermer tous les panels enfants
    const panelId = panel.id;
    const childPanels = elements.drawer.querySelectorAll(`[id^="${panelId}-"]`);
    childPanels.forEach(child => {
      child.classList.remove('is-visible');
      child.style.display = 'none';
    });
    
    // Retirer de l'historique
    state.history = state.history.filter(item => {
      const itemPanel = document.getElementById(item.panelId);
      return itemPanel && itemPanel.classList.contains('is-visible');
    });
  }
  
  function navigateBack() {
    if (state.history.length === 0) return;
    
    const lastItem = state.history.pop();
    const panelToHide = document.getElementById(lastItem.panelId);
    
    if (panelToHide) {
      closePanelAndChildren(panelToHide);
    }
    
    if (state.history.length > 0) {
      state.currentLevel = state.history[state.history.length - 1].level;
    } else {
      state.currentLevel = 0;
      elements.container.classList.remove('has-subpanel');
    }

    fitDrawer();
    updateBreadcrumb();
  }
  
  function updateBreadcrumb() {
    const breadcrumb = elements.drawer.querySelector('#drawerBreadcrumb');
    if (!breadcrumb) return;
    
    if (state.currentLevel === 0) {
      breadcrumb.style.display = 'none';
    } else {
      breadcrumb.style.display = 'flex';
      
      const breadcrumbText = breadcrumb.querySelector('.breadcrumb-text');
      if (breadcrumbText && state.history.length > 0) {
        const currentPanel = document.getElementById(state.history[state.history.length - 1].panelId);
        if (currentPanel) {
          const text = currentPanel.querySelector('.breadcrumb-text');
          if (text) {
            breadcrumbText.textContent = text.textContent;
          }
        }
      }
    }
  }
  
  function saveScrollPosition() {
    state.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  }
  
  function restoreScrollPosition() {
    requestAnimationFrame(() => {
      window.scrollTo({
        top: state.scrollPosition,
        behavior: 'instant'
      });
    });
  }
  
  function lockBody() {
    document.body.style.top = `-${state.scrollPosition}px`;
    document.body.classList.add('drawer-open');
  }
  
  function unlockBody() {
    document.body.classList.remove('drawer-open');
    document.body.style.top = '';
  }
  
  function trapFocus() {
    const focusableElements = elements.drawer.querySelectorAll(
      'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    
    if (focusableElements.length === 0) return;
    
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    
    function handleTab(e) {
      if (e.key !== 'Tab') return;
      
      if (e.shiftKey) {
        if (document.activeElement === firstElement) {
          lastElement.focus();
          e.preventDefault();
        }
      } else {
        if (document.activeElement === lastElement) {
          firstElement.focus();
          e.preventDefault();
        }
      }
    }
    
    elements.drawer.addEventListener('keydown', handleTab);
    elements.drawer._focusTrap = handleTab;
    
    setTimeout(() => firstElement.focus(), 100);
  }
  
  function removeFocusTrap() {
    if (elements.drawer._focusTrap) {
      elements.drawer.removeEventListener('keydown', elements.drawer._focusTrap);
      delete elements.drawer._focusTrap;
    }
  }
  
  function handleKeyboard(e) {
    if (!state.isOpen) return;
    
    switch(e.key) {
      case 'Escape':
        close();
        break;
      case 'ArrowLeft':
        if (state.currentLevel > 0) {
          navigateBack();
          e.preventDefault();
        }
        break;
    }
  }
  
  function updateResponsive() {
    state.isMobile = window.innerWidth <= 768;
    fitDrawer();
  }

  // Sur ORDINATEUR : tous les tiroirs ouverts restent ENTIÈREMENT visibles,
  // quelle que soit la taille d'écran. Si la somme des largeurs préférées
  // dépasse l'écran, on réduit toutes les largeurs à parts égales pour que
  // l'ensemble tienne. Sur MOBILE : on retire les largeurs forcées (les
  // sous-tiroirs se superposent sur 90% de l'écran via le CSS, 90vw).
  var PANEL_W = 680;       // largeur préférée du tiroir principal
  var PANEL_SUB_W = 400;   // largeur préférée d'un sous-tiroir

  function preferredWidth(panel) {
    return panel.classList.contains('drawer-panel-sub') ? PANEL_SUB_W : PANEL_W;
  }

  function fitDrawer() {
    if (!elements.container || !elements.drawer) return;

    var allPanels = elements.drawer.querySelectorAll('.drawer-panel');

    if (window.innerWidth <= 768) {
      allPanels.forEach(function(p) { p.style.removeProperty('width'); });
      return;
    }

    var main = elements.drawer.querySelector('.drawer-panel[data-panel-level="0"]');
    var subs = Array.prototype.slice.call(
      elements.drawer.querySelectorAll('.drawer-panel-sub.is-visible')
    );
    var panels = main ? [main].concat(subs) : subs;
    if (!panels.length) return;

    var available = window.innerWidth;
    var totalPreferred = panels.reduce(function(sum, p) {
      return sum + preferredWidth(p);
    }, 0);

    if (totalPreferred <= available) {
      // Tout tient à la largeur préférée.
      panels.forEach(function(p) { p.style.width = preferredWidth(p) + 'px'; });
    } else {
      // Réduction à parts égales pour que TOUT tienne à l'écran.
      var w = Math.floor(available / panels.length);
      panels.forEach(function(p) { p.style.width = w + 'px'; });
    }
  }
  
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();
